import { z } from 'zod/v4-mini';
import { queryProcedure } from '../trpc/common.js';
import type { ApiParams } from '../types/ApiParams.js';

export function getSessionId(params: ApiParams<void, 'session', 'id'>): string | undefined {
  return params.ctx.session?.id;
}

// Attach a trpc procedure to the function.
getSessionId.procedure = queryProcedure(getSessionId, z.void(), z.union([z.string(), z.undefined()]));
